import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslocoPipe } from '@jsverse/transloco';
import { ADMIN_NAV_ITEMS } from '../../utils/admin-nav.util';

@Component({
    selector: 'app-admin-side-nav',
    standalone: true,
    imports: [RouterLink, RouterLinkActive, MatButtonModule, MatIconModule, MatTooltipModule, TranslocoPipe],
    templateUrl: './admin-side-nav.component.html',
    styleUrl: './admin-side-nav.component.scss',
    host: {
        '[class.collapsed]': 'isCollapsed',
    },
})
export class AdminSideNavComponent {
    public readonly navItems = ADMIN_NAV_ITEMS;
    public isCollapsed: boolean = false;

    public toggleNav(): void {
        this.isCollapsed = !this.isCollapsed;
    }
}
